module.exports = __webpack_public_path__ + "static/img/son4_active.93dc62d6.png";